import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Card, CardHeader } from '@material-ui/core';
import CommentIcon from '@material-ui/icons/Comment';
import { Link } from 'react-router-dom';

import { Bar } from 'react-chartjs-2';

const styles = {
  titleLink: { textDecoration: 'none', color: '#000' },
  card: { borderLeft: 'solid 4px #ff9800', flex: 1, marginTop: '1em' },
  icon: { float: 'right', width: 64, height: 64, padding: 16, color: '#ff9800' },
};

const options = {
  legend: false,
};

const location = { pathname: 'articles' };

const ArticleStats = ({ hourly = { data: [], total: 0 }, classes }) => {
  const hourlyMap = new Map();
  hourly.data.forEach(el => {
    hourlyMap.set(el.hour, el.categories);
  });
  const labels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
  const data = {
    labels,
    datasets: [
      {
        data: labels.map(
          l =>
            hourlyMap.get(l + '') &&
            hourlyMap.get(l + '').reduce((t, c) => {
              t += c.count;
              return t;
            }, 0),
        ),
      },
    ],
  };

  return (
    <Card className={classes.card}>
      <CommentIcon className={classes.icon} />
      <CardHeader
        title={
          <Link to={location} className={classes.titleLink}>
            {`Articles (${hourly.total})`}
          </Link>
        }
        subtitle={`Hourly distribution for last 24h`}
      />
      <Bar data={data} options={options} />
    </Card>
  );
};

ArticleStats.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ArticleStats);


// WEBPACK FOOTER //
// ./src/dashboard/ArticlesStats.js